import { useState, useEffect } from "react";
import { Phone, Star } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function StickyPhoneBanner() {
  const [config, setConfig] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/api/config`)
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(console.error);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      // Show banner after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!config || !isVisible) return null;

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-[100] bg-gradient-to-r from-orange-500 to-orange-600 shadow-lg transform transition-transform duration-300 hidden md:block"
      style={{ transform: isVisible ? 'translateY(0)' : 'translateY(-100%)' }}
      data-testid="sticky-phone-banner"
    >
      <div className="container-custom py-3">
        <div className="flex items-center justify-between">
          {/* Left side - Trust indicators */}
          <div className="flex items-center gap-6">
            <span className="text-white font-medium text-sm hidden lg:block">
              Dépannage serrures Fichet 7j/7 - 24h/24
            </span>
            {/* Google Reviews Badge */}
            <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full">
              <img 
                src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" 
                alt="Google" 
                className="h-4"
              />
              <div className="flex items-center gap-1">
                <span className="text-white font-bold text-sm">4.9</span>
                <div className="flex">
                  {[1,2,3,4,5].map(i => (
                    <Star key={i} className="w-3 h-3 text-yellow-300 fill-yellow-300" />
                  ))}
                </div>
              </div>
              <span className="text-white/80 text-xs hidden sm:inline">(127 avis)</span>
            </div>
          </div>

          {/* Right side - Phone CTA */}
          <a
            href={config.phone_link}
            onClick={() => { if(window.gtag_report_conversion) window.gtag_report_conversion(config.phone_link); }}
            className="flex items-center gap-3 bg-white text-orange-600 px-6 py-2 rounded-lg font-bold hover:bg-orange-50 transition-colors animate-pulse"
            data-testid="sticky-phone-btn"
          >
            <Phone className="w-5 h-5" />
            <span className="text-lg">{config.phone}</span>
            <span className="hidden lg:inline text-sm font-normal text-gray-600">- Appelez maintenant</span>
          </a>
        </div>
      </div>
    </div>
  );
}
